module.exports = __webpack_public_path__ + "static/media/pg.bf9caad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pg.png
// module id = 1954
// module chunks = 0